import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'clicklease-ui-elements';
import { environment } from '@envs/environment';
import { OTPData, OTPResponse } from './../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class OtpService extends RequestService {
    protected readonly serviceBaseUrl: string = `${environment.API_URL}one-time-password/`;

    public sendOtp(phoneNumber: string): Observable<OTPResponse> {
        return this.post<OTPResponse>({
            url: 'send',
            params: { phoneNumber },
            headers: {
                'content-type': 'application/json',
            }
        });
    }

    public validateOTP(otpData: OTPData): Observable<OTPResponse> {
        return this.post<OTPResponse>({
            url: 'validate',
            params: otpData,
            headers: {
                'content-type': 'application/json',
            }
        });
    }
}